import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomerImageModule } from '@max/customer/image/customer-image.module';
import { CustomerSearchSharedModule } from '@max/customer/search/search-shared.module';
import { MaterialModule } from '../../material.module';
import { SearchModule } from '../search/search.module';
import { CustomerAdvancedResultsComponent } from './customer-advanced-results.component';
import { CustomerOmnisearchResultsComponent } from './customer-omnisearch-results.component';
import { CustomerSearchBarComponent } from './customer-search-bar.component';
import { CustomerSearchViewModalComponent } from './search-modal.component';

@NgModule({
    declarations: [
        CustomerSearchBarComponent,
        CustomerOmnisearchResultsComponent,
        CustomerAdvancedResultsComponent,
        CustomerSearchViewModalComponent
    ],
    imports: [
        CustomerSearchSharedModule,
        CommonModule,
        MaterialModule,
        SearchModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        CustomerImageModule
    ],
    exports: [
        CustomerSearchBarComponent,
        CustomerOmnisearchResultsComponent,
        CustomerAdvancedResultsComponent,
        CustomerSearchViewModalComponent
    ]
})
export class CustomerSearchBarModule {
}
